import { create } from 'zustand';

import type { CryptoOperation } from 'models/crypto';

interface CryptoCitizenshipDialogState {
    isOpen: boolean;
    accountName: string;
    callbackOperation: CryptoOperation;
    actions: {
        open: () => void;
        close: () => void;
        setAccountName: (value: string) => void;
        setCallbackOperation: (value: CryptoOperation) => void;
        dispose: () => void;
    };
}

export const useCryptoCitizenshipDialogStore = create<CryptoCitizenshipDialogState>()((set) => ({
    isOpen: false,
    accountName: '',
    callbackOperation: 'deposit',
    actions: {
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
        setAccountName: (value) => set({ accountName: value }),
        setCallbackOperation: (value) => set({ callbackOperation: value }),
        // Called when the crypto flow that owns this dialog is invalidated (logout,
        // forced disconnect). The dialog's Continue button keeps its loading flag in
        // local state and only clears it from the account-creation callbacks, which a
        // torn-down flow never invokes — so closing here is what unmounts the dialog
        // and drops that flag, instead of carrying a stuck spinner into the next login.
        dispose: () => set({ isOpen: false, accountName: '', callbackOperation: 'deposit' }),
    },
}));
